import { useEffect } from "react";
import { encodeState, decodeState } from "../../utils/urlState";
import { usePrevious } from "../../utils/usePrevious";

export function useUrlSyncedState({
  page, pageSize, search, sortDirection, restored, setRestored, setHadHash
}) {

  // --- RESTORE ON MOUNT ------------------------------------
  useEffect(() => {
	const hash = window.location.hash.slice(1);
	if (!hash) {
      setHadHash(false);
	  setRestored(true);
	  return;
	}

	const restoredState = decodeState(hash);
	if (!restoredState) {
      setHadHash(false);
	  setRestored(true);
	  return;
	}

	setHadHash(true);
	page.set(restoredState.page);
	pageSize.set(restoredState.pageSize);
	search.set(restoredState.search);
	sortDirection.set(restoredState.sortDirection);

	setRestored(true);        // we are done restoring
  }, []);

  // --- TRACK PREVIOUS VALUES --------------------------------
  const prev = {
	page: usePrevious(page.value),
	pageSize: usePrevious(pageSize.value),
	search: usePrevious(search.value),
	sortDirection: usePrevious(sortDirection.value)
  };

  // --- UPDATE URL WHEN USER CHANGES STATE -------------------
  useEffect(() => {
	if (!restored) return;  // prevent initial overwrite

	let changed = [];

	if (prev.page !== page.value) changed.push("page");
	if (prev.pageSize !== pageSize.value) changed.push("pageSize");
	if (JSON.stringify(prev.search) !== JSON.stringify(search.value)) changed.push("search");
	if (prev.sortDirection !== sortDirection.value) changed.push("sortDirection");

	if (changed.length === 0) return;

	console.info("State updated by:", changed);

	const newState = {
	  page: page.value,
	  pageSize: pageSize.value,
	  search: search.value,
	  sortDirection: sortDirection.value
	};

	window.location.hash = encodeState(newState);

  }, [
	page.value,
	pageSize.value,
	search.value,
	sortDirection.value,
	restored
  ]);
}
